export const logoutUser = () => {
    localStorage.removeItem('user-message');
};
